import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import {
  ADMIN_LEADERBOARD_ALLOWED_PATHS,
  TRANSACTION_HOME_PATH,
  isAdminLeaderboardRole,
  isCashierOrFloorSupervisor,
  isManagementOnlyPath,
} from '../constants/roles';

const RoleProtectedRoute = ({ children }) => {
  const location = useLocation();
  const userData = localStorage.getItem('user');

  if (!userData) {
    return children;
  }

  try {
    const { role } = JSON.parse(userData);

    if (isAdminLeaderboardRole(role)) {
      const isAllowed = ADMIN_LEADERBOARD_ALLOWED_PATHS.some(
        (path) =>
          location.pathname === path ||
          location.pathname.startsWith(`${path}/`)
      );

      if (!isAllowed) {
        return <Navigate to="/tournament-leaderboard" replace />;
      }
    }

    // Cashier & Floor Supervisor: Transactions + EPL Players only (no Management)
    if (isCashierOrFloorSupervisor(role) && isManagementOnlyPath(location.pathname)) {
      return <Navigate to={TRANSACTION_HOME_PATH} replace />;
    }
  } catch (error) {
    console.error('Error parsing user data for role check:', error);
  }

  return children;
};

export default RoleProtectedRoute;
